import { ForgeSlider } from '@tylertech/forge-react';
import { type PreviewSettings } from '../types';
import { PRINT_PREVIEW_FONT_SLIDER_CONFIG } from '../templates/section/defaultStyles';
import styles from './font-size-slider.module.scss';

interface FontSizeSliderProps {
  fontSize: number;
  onChange: <K extends keyof PreviewSettings>(key: K, value: PreviewSettings[K]) => void;
}

const FontSizeSlider = ({ fontSize, onChange }: FontSizeSliderProps) => {
  const handleSliderChange = (e: CustomEvent) => {
    onChange('fontSize', e.detail.value);
  };

  return (
    <div className="pdf-preview-modal__settings-group">
      <label>Text size</label>
      <ForgeSlider
        className={styles['font-size-slider']}
        data-testid="pdf-font-size-slider"
        role="forge-slider"
        type="continuous"
        min={PRINT_PREVIEW_FONT_SLIDER_CONFIG.MIN}
        max={PRINT_PREVIEW_FONT_SLIDER_CONFIG.MAX}
        value={fontSize}
        step={PRINT_PREVIEW_FONT_SLIDER_CONFIG.STEP}
        on-forge-slider-change={handleSliderChange}
      />
    </div>
  );
};

export default FontSizeSlider;
